"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const and_1 = require("../generics/and");
const at_1 = require("../generics/at");
const isObject_1 = require("./isObject");
exports.hasObjectConstructor = at_1.at('constructor', (value) => value === Object);
exports.isPlainObject = and_1.and(isObject_1.isObject, (value) => exports.hasObjectConstructor(Object.getPrototypeOf(value)) && String(value) === '[object Object]');
//# sourceMappingURL=isPlainObject.js.map